import Reveal from "@/components/base/Reveal";
import { BRAND } from "@/constants/site";
import { storyParagraphs } from "@/mocks/sobre";

export default function SobreStory() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
                <i className="ri-book-open-line" aria-hidden="true"></i>
                Nossa história
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Uma empresa de tecnologia construída sobre confiança.
              </h2>
              <div className="mt-5 space-y-4">
                {storyParagraphs.map((paragraph) => (
                  <p key={paragraph} className="text-base leading-relaxed text-foreground-600">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20technology%20company%20office%20with%20server%20racks%20and%20professionals%20working%2C%20glass%20walls%20and%20dark%20blue%20ambient%20lighting%2C%20premium%20corporate%20infrastructure%20photography%2C%20clean%20and%20sophisticated&width=1200&height=900&seq=nh-sobre-story&orientation=landscape"
                  alt="Equipe e infraestrutura de servidores da NXHOST"
                  title="NXHOST — empresa de tecnologia, hospedagem e infraestrutura digital"
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-6 -left-2 hidden w-52 rounded-xl border border-background-200 bg-background-50 p-5 sm:block">
                <p className="font-heading text-2xl font-bold text-foreground-950">2007</p>
                <p className="mt-1 text-xs leading-snug text-foreground-600">
                  Ano em que a {BRAND} iniciou a sua trajetória
                </p>
              </div>

              <div className="absolute -right-3 -top-4 hidden h-12 w-12 items-center justify-center rounded-xl border border-background-200 bg-background-50 text-primary-600 md:flex">
                <i className="ri-server-line text-2xl" aria-hidden="true"></i>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}